var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fa-icon',{class:'no-print',attrs:{"icon":['activity', _vm.activity]}})
}
var staticRenderFns = []

export { render, staticRenderFns }